module.exports = __webpack_public_path__ + "img/digital_assistant.39bf5782.svg";